 <template>
  <v-dialog
    :value="value"
    persistent
    max-width="500px">
      <v-toolbar color="primary" dark dense>
        <v-toolbar-title>Запрос {{claim.DOC_NUM}} ({{claim.DOC_STATUS}}): Действие</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="doCancel">mdi-close</v-icon>
      </v-toolbar>
      <v-card>
        <v-card-title class="headline">
          Перевести запрос в статус:
        </v-card-title>
        <v-card-text class=" black--text">
          <v-select
            :items="orderStatusItems"
            item-text="NEXT_STATE_NAME"
            item-value="SIGNAL_ID"
            label="Доступные статусы"
            v-model="nextStatus"
            return-object
            :loading="statusesLoading"
            no-data-text="Нет доступных действий"
            dense
          ></v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="secondary"
            outlined
            @click="doCancel"
          >
            Отмена
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            :disabled="!sendActive"
            @click="doOK"
          >
            Изменить статус запроса
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>

import { CLM_POST_CLAIM } from '@/store/actions/claims'

export default {
  name: 'claimActionDialog',
  data () {
    return {
      nextStatus: {},
      statusesLoading: false
    }
  },
  props: ['value', 'claim'],
  watch: {},
  computed: {
    sendActive: {
      get: function () {
        return ('SIGNAL_ID' in this.nextStatus)
      }
    },
    orderStatusItems: {
      get: function () {
        return this.claim.AVAIL_STATUS
      }
    }
  },
  methods: {
    doOK () {
      console.log('Confirmed status ', this.nextStatus)
      this.$store.dispatch(CLM_POST_CLAIM, { PTC: 'state', DOC_ID: this.claim.DOC_ID, DS_ID: this.claim.DS_ID, SIGNAL_ID: this.nextStatus.SIGNAL_ID })
      this.nextStatus = {}
      this.$emit('input', false)
    },
    doCancel () {
      this.nextStatus = {}
      this.$emit('input', false)
    }
  },
  created: function () {
    console.log('Order action dialog created')
  }

}
</script>
